module.exports = __webpack_public_path__ + "static/img/B03-沈阳私立实验学校1.d0e8a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B03-沈阳私立实验学校1.png
// module id = eGXu
// module chunks = 0